<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">รายการสมัครสมาชิก</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ดูรายละเอียดและแก้ไขรายการที่ยังไม่ชำระ (ยังไม่หมดอายุ)</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div
        class="flex items-center gap-2 px-3 py-2 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm h-[46px]">
        <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">calendar_today</span>
        <input type="date" [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate || undefined"
          class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[115px] dark:[color-scheme:dark]">
        <span class="text-slate-300 dark:text-slate-600">-</span>
        <input type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate || undefined"
          class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[115px] dark:[color-scheme:dark]">
        <button *ngIf="startDate || endDate" (click)="clearDateFilter()"
          class="ml-1 w-6 h-6 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 hover:text-amber-500 transition-colors"
          title="ล้างช่วงวันที่">
          <span class="material-icons text-[16px]">close</span>
        </button>
      </div>

      <button (click)="toggleDashboard()"
        class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2"
        [title]="showDashboard ? 'ซ่อนสรุป' : 'แสดงสรุป'">
        <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
        <span class="text-sm font-bold">{{ showDashboard ? 'ซ่อนสรุป' : 'แสดงสรุป' }}</span>
      </button>

      <button (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <!-- Collapsible Dashboard -->
  <div class="overflow-hidden transition-all duration-500 ease-in-out"
    [style.max-height]="showDashboard ? '800px' : '0'" [style.opacity]="showDashboard ? '1' : '0'"
    [style.margin-bottom]="showDashboard ? '2rem' : '0'">
    <div class="flex items-center justify-between mb-4">
      <p class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
        สรุปตามช่วงวันที่: <span class="text-slate-600 dark:text-slate-300">{{ tableDateRangeLabel }}</span>
      </p>
    </div>
    <div *ngIf="dashboardStats.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-2">
      <div *ngFor="let stat of dashboardStats; let i = index"
        class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
        [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">
        <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
          [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>
        <div class="relative z-10 flex justify-between items-start mb-4">
          <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
            [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
            <span class="material-icons text-2xl">{{ stat.icon }}</span>
          </div>
        </div>
        <div class="relative z-10">
          <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Card -->
  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.2s;">
    <div
      class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">person_add</span>
        รายการสมัครสมาชิก
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </h3>

      <div class="flex flex-col md:flex-row gap-3 w-full lg:flex-1 lg:min-w-0 lg:justify-end">
        <!-- Status Filter -->
        <div
          class="flex flex-wrap items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl min-h-[46px] shadow-sm">
          <button (click)="selectStatus(1)"
            [class]="filterStatus === 1 ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400'"
            class="px-3 h-[38px] rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
            ยังไม่ชำระ
          </button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button (click)="selectStatus(2)"
            [class]="filterStatus === 2 ? 'bg-white dark:bg-slate-700 text-green-600 dark:text-green-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-green-600 dark:hover:text-green-400'"
            class="px-3 h-[38px] rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
            ชำระแล้ว
          </button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button (click)="selectStatus(3)"
            [class]="filterStatus === 3 ? 'bg-white dark:bg-slate-700 text-rose-600 dark:text-rose-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-rose-600 dark:hover:text-rose-400'"
            class="px-3 h-[38px] rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
            ยกเลิก
          </button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button (click)="selectStatus(4)"
            [class]="filterStatus === 4 ? 'bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-300 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'"
            class="px-3 h-[38px] rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
            หมดอายุแล้ว
          </button>
        </div>

        <!-- Search Group -->
        <div
          class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible w-full md:flex-1 md:min-w-[360px] relative z-30">
          <div class="relative min-w-[120px] shrink-0 border-r border-slate-200 dark:border-slate-700">
            <button (click)="toggleSearchTypeDropdown()"
              class="w-full pl-4 pr-3 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none h-[46px]">
              <span>{{ currentSearchTypeLabel }}</span>
              <span class="material-icons text-sm text-slate-400 dark:text-slate-500 transition-transform duration-200"
                [ngClass]="{'rotate-180': isSearchTypeDropdownOpen}">expand_more</span>
            </button>
            <button *ngIf="isSearchTypeDropdownOpen" class="fixed inset-0 cursor-default z-40"
              (click)="toggleSearchTypeDropdown()"></button>
            <div *ngIf="isSearchTypeDropdownOpen"
              class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden">
              <button (click)="selectSearchType('memberName')"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">person</span>
                ชื่อสมาชิก
              </button>
              <button (click)="selectSearchType('license')"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">directions_car</span>
                ทะเบียนรถ
              </button>
              <button (click)="selectSearchType('phone')"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">phone</span>
                เบอร์โทร
              </button>
              <button (click)="selectSearchType('requestNo')"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">tag</span>
                เลขที่คำขอ
              </button>
            </div>
          </div>
          <div class="relative flex-1">
            <span
              class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()"
              [placeholder]="searchPlaceholder"
              class="w-full pl-10 pr-4 py-2.5 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600 rounded-r-xl h-[46px]">
          </div>
          <button (click)="onSearch()"
            class="shrink-0 px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all h-[46px] mr-1">
            ค้นหา
          </button>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto h-[600px] relative custom-scrollbar" [class.opacity-50]="isLoading">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
              เลขที่คำขอ
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
              ชื่อสมาชิก
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
              เบอร์โทร
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
              ทะเบียนรถ
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
              แพ็คเกจ
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-right whitespace-nowrap">
              ค่าธรรมเนียม
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
              วันหมดอายุ
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center whitespace-nowrap">
              สถานะ
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">
              จัดการ
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let row of rows; let i = index"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200 cursor-pointer"
            [ngStyle]="{'animation-delay': (i * 0.03) + 's'}" (click)="openDetailModal(row.id)">
            <td class="p-5 font-mono text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors whitespace-nowrap">
              {{ row.requestNo || '-' }}
            </td>
            <td class="p-5 whitespace-nowrap">
              <div class="flex items-center gap-3">
                <div
                  class="flex-shrink-0 w-9 h-9 rounded-full bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center text-slate-500 dark:text-slate-400 font-bold text-xs shadow-sm group-hover:bg-white dark:group-hover:bg-slate-800 group-hover:text-amber-500 dark:group-hover:text-amber-400 transition-colors">
                  {{ row.memberName ? row.memberName.charAt(0) : '?' }}
                </div>
                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ row.memberName || '-' }}</span>
              </div>
            </td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">{{ row.phone || '-' }}</td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">
              {{ row.license || '-' }}<span *ngIf="row.province" class="text-slate-400 dark:text-slate-500"> ({{ row.province }})</span>
            </td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">{{ row.feeName || '-' }}</td>
            <td class="p-5 text-right font-bold text-slate-700 dark:text-slate-200 whitespace-nowrap">
              {{ row.fee | number:'1.0-0' }} ฿
            </td>
            <td class="p-5 whitespace-nowrap text-sm text-slate-500 dark:text-slate-400 font-medium">
              {{ formatDateTime(row.expireDate) }}
            </td>
            <td class="p-5 text-center">
              <span
                class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                [ngClass]="statusClass(row.displayStatus)">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5" [ngClass]="statusDotClass(row.displayStatus)"></span>
                {{ statusLabel(row.displayStatus) }}
              </span>
            </td>
            <td class="p-5 text-center whitespace-nowrap" (click)="$event.stopPropagation()">
              <button (click)="openDetailModal(row.id)"
                class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 dark:hover:bg-blue-600 hover:text-white transition-all shadow-sm hover:shadow-blue-200 dark:hover:shadow-blue-900/50"
                title="ดูรายละเอียด">
                <span class="material-icons text-[18px]">visibility</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0 && !isLoading">
            <td colspan="9" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center">
                <div class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                  <span class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                </div>
                <h3 class="text-slate-800 dark:text-slate-200 font-bold">ไม่พบข้อมูล</h3>
                <span class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองปรับตัวกรองหรือค้นหาใหม่อีกครั้ง</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
          class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-600 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="p === currentPage ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'">
          {{ p }}
        </button>
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage >= totalPages || totalPages === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-register-member-detail *ngIf="isModalDetailOpen" [id]="selectedRegisterMemberId" [siteId]="selectedSiteId"
  [userId]="userId" [menuId]="menuId" (close)="closeDetailModal()" (save)="onDetailSaved()">
</app-modal-register-member-detail>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
